export default {"src":"/_next/static/media/flag.ff8f90c1.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};